import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getApiSettings } from './api';
import { request } from '@vfde-fe/sails_core';

import {
    DISCONNECT_WEBCHAT,
} from './constants';
import {
    disconnectWebchatFailed,
    disconnectWebchatSuccess,
} from './actions';

import {
    DisconnectWebchatConfig,
} from './api';

import getApiPath from 'Helper/getApiPath';

import {
    selectWebchatConfigUserId,
    selectWebchatConfigAlias,
    selectWebchatConfigSecureKey,
    selectWebchatConfigChatId,
} from 'Container/InitWebchat/selector';
import {TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE} from 'Container/Tracking/constants';
import { selectWebchatPath } from 'Container/Ui/selector';

/**
 * sendMessage
 */
export function* disconnectWebchat () {
    try {

        const [userId, alias, secureKey, chatId, webchatPath] =
        yield all ([
            select(selectWebchatConfigUserId()),
            select(selectWebchatConfigAlias()),
            select(selectWebchatConfigSecureKey()),
            select(selectWebchatConfigChatId()),
            select(selectWebchatPath()),
        ]);

        const data: DisconnectWebchatConfig = {
            userId: userId,
            alias: alias,
            secureKey: secureKey,
        };

        const apiSettings = getApiSettings(data);

        const apiPath = getApiPath(chatId, 'disconnect', webchatPath);

        const response = yield call(request, apiPath, apiSettings);

        // create and yield a dispatch Effect
        yield put(disconnectWebchatSuccess(response.body));
    } catch (error) {
        yield put(disconnectWebchatFailed(true, error?.res?.status || TRACKING_WEBCHAT_ERROR_MESSAGE_NOT_AVAILBLE));
    }

  }

/**
 *  sendMessageSaga
 */
export default function* disconnectWebchatSaga () {
    yield takeLatest(DISCONNECT_WEBCHAT, disconnectWebchat);
}
